import { toast } from "@jsq/ds/core";
import { ProgramType } from "~/graphql/supergraphEnums";
import { useSetEntityProgramMutation } from "~/graphql/supergraphHooks";
import { ApplyProgramOutcome, SingleProgramTab } from "../SingleProgramTab";
import { SettingsDrawerTabProps } from "../types";

export const EntityProgramTab = (props: SettingsDrawerTabProps) => {
  const { row } = props;

  const [setEntityProgram] = useSetEntityProgramMutation({
    onError: (e) => toast.error(e.message),
  });

  const applyProgram = async (programType: ProgramType): Promise<ApplyProgramOutcome> => {
    const result = await setEntityProgram({
      variables: {
        // The slice row carries plain db ids, as the CB subgraph expects
        accountId: Number(row.id),
        arenaId: Number(row.arenaId),
        programType,
      },
    });
    if (result.data?.setEntityProgram?.ok) return "saved";
    return result.data?.setEntityProgram ? "rejected" : "errored";
  };

  return (
    <SingleProgramTab
      {...props}
      subject="entity"
      programLabel="Entity AML/KYC compliance program"
      description="Configure the compliance program that clients must comply with when onboarding their entities on to the Juniper Square platform."
      assignedProgram={row.entityProgram}
      successToast={`Entity program updated for ${row.name}`}
      applyProgram={applyProgram}
    />
  );
};
